import type { VideoModelConfig } from '../../types';

/** Seedance 2.5（多模态独占 + 真人视频，行为与 Seedance 2.0 一致） */
export const seedance2_5: VideoModelConfig = {
  id: '01KZDKGGERX2MFRYEYKP0RDN3N',
  displayName: 'Seedance 2.5',
  defaults: {
    ratio: '9:16',
    resolution: '720P',
    duration: 5,
    sound: 'on',
  },
  ratioOptions: [
    { label: '1:1', value: '1:1' },
    { label: '3:4', value: '3:4' },
    { label: '4:3', value: '4:3' },
    { label: '9:16', value: '9:16' },
    { label: '16:9', value: '16:9' },
    { label: '21:9', value: '21:9' },
    { label: '自适应', value: 'adaptive' },
  ],
  resolutionOptions: [
    { label: '480P', value: '480P' },
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'range', min: 4, max: 30, step: 1, default: 5 },
  capabilities: {
    refVideo: true,
    refAudio: true,
    sound: true,
    realVideo: true,
    multiModalReference: true,
    forceAdaptiveKeyframe: true,
    multiVideo: true,
  },
  limits: {
    maxRefImages: 30,
    maxRefVideos: 10,
    maxRefAudios: 10,
    // 参考视频上传约束（转写自 VideoSelectModal 原硬编码）：格式 mp4/mov、单文件 ≤200MB、时长 [2,30]s、总时长 ≤30s
    refVideoConstraints: {
      formats: ['mp4', 'mov'],
      maxFileSizeMB: 200,
      duration: { min: 2, max: 30, totalMax: 30 },
      hintKey: 'imageCreation.videoUploadHintSeedance25',
    },
    // 参考音频上传约束（转写自 AudioSelectModal 原硬编码）：格式 wav/mp3、单文件 ≤15MB、时长 [2,30]s
    refAudioConstraints: {
      formats: ['wav', 'mp3'],
      maxFileSizeMB: 15,
      duration: { min: 2, max: 30 },
      hintKey: 'imageCreation.audioUploadHint30s',
    },
    // 提交前参考图约束（汇总层校验）：jpg/jpeg/png/webp/bmp/tiff/tif/gif、尺寸 300~6000、宽高比 [0.4,2.5]、单张 ≤30MB
    refImageSubmitConstraints: {
      formats: ['jpg', 'jpeg', 'png', 'webp', 'bmp', 'tiff', 'tif', 'gif'],
      dimension: { min: 300, max: 6000 },
      aspectRatio: { min: 0.4, max: 2.5 },
      maxFileSizeMB: 30,
    },
    // 提交前参考视频约束（汇总层校验）：mp4/mov、单文件 ≤200MB、尺寸 300~6000、宽高比 [0.4,2.5]、像素 [409600,8295044]、单段 2~30s、合计 ≤30.1s
    refVideoSubmitConstraints: {
      formats: ['mp4', 'mov'],
      maxFileSizeMB: 200,
      dimension: { min: 300, max: 6000 },
      aspectRatio: { min: 0.4, max: 2.5 },
      pixelCount: { min: 409600, max: 8295044 },
      duration: { min: 2, max: 30, totalMax: 30.1 },
      errorKeys: {
        totalDuration: 'imageCreation.seedance25RefVideoTooLong',
      },
    },
    // 提交前参考音频约束（汇总层校验）：wav/mp3、单文件 ≤15MB、单段 2~30s、合计 ≤30.1s
    refAudioSubmitConstraints: {
      formats: ['wav', 'mp3'],
      maxFileSizeMB: 15,
      duration: { min: 2, max: 30, totalMax: 30.1 },
      errorKeys: {
        format: 'imageCreation.seedance25RefAudioFormatNotSupported',
        size: 'imageCreation.seedance25RefAudioSizeExceeded',
        durationMin: 'imageCreation.seedance25RefAudioDurationOutOfRange',
        durationMax: 'imageCreation.seedance25RefAudioDurationOutOfRange',
        totalDuration: 'imageCreation.seedance25RefAudioTooLong',
      },
    },
  },
  /** 画布扩展（Tab/连线/开关等节点式业务专属字段，从画布 configs/seedance-2.5.ts 迁移） */
  canvas: {
    defaults: {
      realVideo: true,
      audioSync: true,
    },
    toggles: {
      realVideo: true,
      audioSync: true,
    },
    ratioLockByTab: {
      '首尾帧': 'adaptive',
      '视频编辑': 'adaptive',
      '视频延长': 'adaptive',
    },
    durationHiddenByTab: ['视频编辑'],
    durationFixedValue: -1,
    durationExt: {
      quickOptions: [],
    },
    capabilities: {
      refVideo: true,
      refAudio: true,
      atMentionTabs: ['全能参考', '图生视频', '视频编辑', '视频延长'],
      videoEdit: true,
      videoExtend: true,
    },
    limits: {
      validateRefImageSize: true,
      refLimitByTab: {
        '视频编辑': { videoRef: 1 },
        '视频延长': { videoRef: 1 },
      },
      refVideoDurationByTab: {
        '视频编辑': { min: 4, max: 30, totalMax: 30 },
      },
    },
  },
};
